import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import DsModal from '@/shared/modal/ds-modal.vue';

@Component({
  components: { DsModal },
})
export default class ScrapAgentAccountConnectDropboxComponent extends Vue {
  @Prop({ type: Boolean, required: true }) open!: boolean;
  @PropSync('channelConnect', { type: Object }) syncedChannelConnect!: any;

  showModal = this.open;
  formData = {
    dataSourceType: 'YOUTUBE',
    GMAIL_MAIL_ALL: '',
    GMAIL_MAIL_PRIMARY: '',
    GMAIL_MAIL_STARTED: '',
    GMAIL_MAIL_KEYWORD: '',
    DAUM_MAIL: '',
    NAVER_MAIL: '',
    OUTLOOK_MAIL: '',
    YAHOO_MAIL_ALL: '',
    YAHOO_MAIL_PRIMARY: '',
    YAHOO_MAIL_STARTED: '',
    YAHOO_MAIL_KEYWORD: '',
  } as any;

  @Watch('open')
  onOpenChange(value: boolean) {
    this.showModal = value;
  }
}
